/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class MinusIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke,
            width = 12,
            height = 4
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path stroke={stroke} fill={fill} fillRule="evenodd" d="M12 0H0v3.265h12z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Minus.tsx